import { useState, useCallback } from 'react';

import { ActiveRoute, resetActiveRoute } from '../types/activeRoute';

const useActiveRoutes = () => {
  const [ activeRoute, setActiveRoute ] = useState<ActiveRoute>();

  const resetActiveRoute: resetActiveRoute = useCallback(() => {
    setActiveRoute(undefined);
  }, []);

  return { activeRoute, setActiveRoute, resetActiveRoute };
};

export default useActiveRoutes;
